// Importation des outils nécessaires depuis Redux Toolkit
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Typage de l'état initial
import { InitialCapsulesStates } from '../../../../../@types/initialCapsulesStates';
// Axios personnalisé avec gestion des tokens
import axiosInstance from 'utils/axios';
// Typage du dispatch Redux
import { AppDispatch } from 'redux/stores/initialStore';
// Typage des capsules (structure des données)
import { Capsules } from '../modeles/modele';
import { startstopLoading } from 'redux/slices/initial.slice';

// -------------------------
// ÉTAT INITIAL DU SLICE
// -------------------------
const initialState: InitialCapsulesStates = {
  //isLoading: false, // Indique si une requête est en cours
  capsules: { items: [], page: 0, pageSize: 20, total: 0, totalPages: 0 }, // Données paginées
  showPrevious: false, // Affiche une capsule précédente ou non
  capsulesSeleted: [],
  showChooseButton: false,
};

// -------------------------
// CRÉATION DU SLICE
// -------------------------
const slice = createSlice({
  name: 'capsule',
  initialState,
  reducers: {
    // Met à jour la liste des capsules
    setCapsules(state, action: PayloadAction<Capsules>) {
      state.capsules = action.payload;
    },
    setShowChooseButton(state, action: PayloadAction<boolean>) {
      state.showChooseButton = action.payload;
    },
    // Affiche ou cache la prévisualisation de la capsule
    setShowPrevious(state, action: PayloadAction<boolean>) {
      state.showPrevious = action.payload;
    },
    // Met à jour la liste des capsules sélectionnées
    setcapsulesSeleted(state, action: PayloadAction<any[]>) {
      state.capsulesSeleted = action.payload;
    },
  },
});

// -------------------------
// EXPORT DU RÉDUCTEUR
// -------------------------
export default slice.reducer;

// -------------------------
// EXPORT DES ACTIONS
// -------------------------
export const {
  // startstopLoading,
  setCapsules,
  setShowPrevious,
  setcapsulesSeleted,
  setShowChooseButton,
} = slice.actions;

// -------------------------
// ACTION : Met à jour les capsules sélectionnées
// -------------------------
export const SetcapsulesSeleted = (capsule: any) => (dispatch: AppDispatch) => {
  dispatch(setcapsulesSeleted(capsule));
};

// -------------------------
// ACTION ASYNCHRONE : Récupère la liste des capsules depuis l'API
// -------------------------
export const SetCapsules =
  (currentPage: number, search: string, orphan: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(startstopLoading(true));
      dispatch(setCapsules({ items: [], page: 0, pageSize: 20, total: 0, totalPages: 0 })); // Reset de la liste
      // Construction de l'URL selon la page
      let url: string = `/external_contents?page=${currentPage}&pageSize=20&search=${search}&orphan=${orphan}`;
      if (currentPage === 0) {
        url = `/external_contents?pageSize=20&search=${search}&orphan=${orphan}`;
      }

      // Appel API
      const response = await axiosInstance.get<any>(url);
      const { data } = response;
      dispatch(setCapsules(data)); // Stocke les données reçues
      dispatch(startstopLoading(false));
    } catch (err) {
      console.log('err', err);
      dispatch(startstopLoading(false));
    }
  };

// -------------------------
// ACTION : Vide la liste des capsules
// -------------------------
export const ClearCapsuleList = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(setCapsules({ items: [], page: 0, pageSize: 20, total: 0, totalPages: 0 }));
  } catch (err) {
    console.log('err', err);
  }
};

// -------------------------
// ACTION : Définit si on affiche la prévisualisation de la capsule
// -------------------------
export const SetShowPrevious = (value: boolean) => (dispatch: AppDispatch) => {
  try {
    dispatch(setShowPrevious(value));
  } catch (err) {
    console.log('err', err);
  }
};

export const LaunchCapsule = async (id: string) => {
  const response = await axiosInstance.get<any>(`/external_contents/${id}/launch/admin`);

  return response.data;
};

export const SetShowChooseButton = (value: boolean) => (dispatch: AppDispatch) => {
  try {
    dispatch(setShowChooseButton(value));
  } catch (err) {
    console.log('err', err);
  }
};
